import { useRef } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import useRevealMotion from '@/hooks/useRevealMotion';
import usePageTransition from '@/hooks/usePageTransition';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Results from './components/Results';
import Process from './components/Process';
import FAQAccordion from './components/FAQAccordion';
import ContactForm from './components/ContactForm';

export default function Home() {
  const mainRef = useRef<HTMLElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);
  useRevealMotion(mainRef, '/');
  usePageTransition([mainRef, footerRef], '/');
  return (
    <div className="bg-background-50 text-foreground-950 overflow-x-hidden">
      <title>CLEARY | Professional Residential Home Cleaning</title>
      <meta name="description" content="CLEARY offers thoughtful residential cleaning: recurring home cleaning, deep cleaning and move-in / move-out cleaning, delivered with care and attention to detail." />
      <Header />
      <main ref={mainRef}>
        <Hero />
        <Services />
        <WhyUs />
        <Results />
        <Process />
        <FAQAccordion />
        <ContactForm />
      </main>
      <div ref={footerRef}><Footer /></div>
    </div>
  );
}